<template>
  <div class="dropdown" id="drop1" :class="dropdownClass">
    <button
      class="dropdown-toggle border-0"
      :class="buttonClass"
      type="button"
      :id="dropdownId"
      data-bs-toggle="dropdown"
      aria-expanded="false"
      style="display: flex; justify-content: space-between; align-items: center;"
    >
      <span>{{ label }}</span>
    </button>
    <ul class="dropdown-menu p-0" :aria-labelledby="dropdownId">
      <li v-if="loading" class="text-center py-2">
        <span class="spinner-border spinner-border-sm text-primary"></span>
      </li>
      <template v-else>
        <li
          v-if="showAllOption"
          @click="onSelect('')"
        >
          <a class="dropdown-item" href="#">{{ allOptionLabel }}</a>
        </li>
        <li
          v-for="item in items"
          :key="getKey(item)"
          @click="onSelect(getValue(item))"
        >
          <a class="dropdown-item" href="#">
            <slot name="item" :item="item">
              {{ getText(item) }}
            </slot>
          </a>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  name: "BaseDropdown",
  props: {
    label: String,
    items: {
      type: Array,
      required: true
    },
    getKey: {
      type: Function,
      default: item => item
    },
    getText: {
      type: Function,
      default: item => item
    },
    getValue: {
      type: Function,
      default: item => item
    },
    onSelect: {
      type: Function,
      required: true
    },
    dropdownId: {
      type: String,
      default: ''
    },
    showAllOption: {
      type: Boolean,
      default: false
    },
    allOptionLabel: {
      type: String,
      default: ''
    },
    dropdownClass: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
     buttonClass: {
      type: String,
      default: ''
    }
  }
};
</script>

<style scoped>
 .dropdown-menu .dropdown-item {
  height: 45px;
  color: white;
  padding-left: 10px;
  padding-top: 10px;
  transition: 0.4s;
}

.dropdown-menu .dropdown-item:hover {
  color: black;
   
}

#drop1 {
  margin-right: 10px;
  
}

.dropdown-toggle {
  background-color: transparent;
  color: #333;
  padding: 10px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 15px;
}

.dropdown-menu {
  border-radius: 4px;
  width: 100%;
  max-width: 200px;
  
}

.dropdown-item {
  cursor: pointer;
  border-bottom:1px solid rgba(250, 250, 250, 0.1);
  transition: background-color 0.3s ease;
}
.filters {
  display: flex;
  margin-bottom: 40px;
}

.filters .dropdown .dropdown-toggle {
  width: 200px;
  color: white;
  margin-top: -10px;
  background: #111c45;
}

</style>